import {
  type QuizQuestionData,
  type QuizQuestionUpdateInput,
  type QuizQuestionUpdateSuccess,
  toResponseError,
} from '@terros/common'
import { useQuizCache } from '../cache'
import { useTantalimMutation } from '../../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../../hooks'

export function useUpdateQuizQuestion(): UpdateHookResponse<QuizQuestionData> {
  const mutation = useTantalimMutation<QuizQuestionUpdateInput, QuizQuestionUpdateSuccess>({
    url: '/quiz/question/update',
  })

  const cache = useQuizCache()

  async function update(question: QuizQuestionData): Promise<QuizQuestionData> {
    try {
      const response = await mutation.mutateAsync({ question })
      cache.clearItem(question.quizId)
      return response.question
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
